import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Avatar, Grid, useTheme, Button } from '@mui/material';
// import { makeStyles } from '@mui/styles';
import StarIcon from '@mui/icons-material/Star';
import { makeStyles } from '@mui/styles';
import { CommonHeading, CommonTitle } from '../../../../layout/Common';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from 'axios';



// const reviews = [
//     {
//         name: 'Karl Leonardo',
//         review: 'Dignissim sodales ut eu sem integer vitae. Curabitur gravida arcu ac tortor. Est sit amet facilisis magna etiam tempor orci eu.',
//         avatar: './images/reviews/review1.jpg',
//         images: [
//             "./images/reviews/review1.jpg",
//             "./images/reviews/review1.jpg",
//             "./images/reviews/review1.jpg",
//             "./images/reviews/review1.jpg"
//         ]

//         // image: './images/reviews/review1.jpg',
//     },
//     {
//         name: 'Georg Renzo',
//         review: 'Commodo ullamcorper a lacus vestibulum sed arcu non. Vulputate dignissim suspendisse in est ante in.',
//         avatar: './images/reviews/review1.jpg',
//     },
//     {
//         name: 'Britta Cornelia',
//         review: 'Ultrices eros in cursus turpis. Aliquet enim tortor at auctor urna. Non blandit massa enim nec dui nunc mattis Est pellentesque.',
//         avatar: './images/reviews/review1.jpg',
//     },
//     {
//         name: 'Britta Cornelia',
//         review: 'Ultrices eros in cursus turpis. Aliquet enim tortor at auctor urna. Non blandit massa enim nec dui nunc mattis Est pellentesque.',
//         avatar: './images/reviews/review1.jpg',
//     },
//     {
//         name: 'Britta Cornelia',
//         review: 'Ultrices eros in cursus turpis. Aliquet enim tortor at auctor urna. Non blandit massa enim nec dui nunc mattis Est pellentesque.',
//         avatar: './images/reviews/review1.jpg',
//     },
//     {
//         name: 'Britta Cornelia',
//         review: 'Ultrices eros in cursus turpis. Aliquet enim tortor at auctor urna. Non blandit massa enim nec dui nunc mattis Est pellentesque.',
//         avatar: './images/reviews/review1.jpg',
//     },
// ];

const Review = () => {
    const theme = useTheme();
    const [AllReviews, setAllReview] = useState([]);
    

    const fetchCustomerReviews = async (filters) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/get-reviews`);
            console.log("response.data", response.data.data);

            setAllReview(response.data.data);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    useEffect(() => {
        fetchCustomerReviews({});
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        loop: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },

            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <Box sx={{ backgroundColor: "#161616", py: '150px' }}>
            <Container maxWidth='xl'>
                <Box sx={{ width: "100%", display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ padding: '0px 10px', width: { lg: '50%', xs: '100%' }, textAlign: 'center', mb: 5 }}>
                        <CommonTitle margin={'10px 0'} text={'review & ratings'} />
                        <CommonHeading margin={'0 0 16px 0'} text={'Positive Customers Feedback'} />
                    </Box>
                </Box>

                <Box>
                    {AllReviews?.length > 1 ? (
                        <Slider {...settings}>
                            {AllReviews.map((review, index) => (
                                <ReviewCard review={review} key={index} />
                            ))}
                        </Slider>
                    ) : (
                        AllReviews.map((review, index) => (
                            <Grid
                                item
                                xs={12}
                                lg={3}
                                key={index}
                                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                <Box
                                    sx={{
                                        padding: { sm: '38px 20px', xs: '18px 20px' },
                                        backgroundColor: '#23201e',
                                        mx: { xxl: 2, xs: 1 },
                                        borderRadius: '8px',
                                    }}
                                >
                                    {review.ReviewImage && Array.isArray(review.ReviewImage) && review.ReviewImage.length > 0 && (
                                        <Box sx={{ mb: 2 }}>
                                            {review.ReviewImage.length === 1 && (
                                                <Box sx={{ width: '100%', height: '250px' }}>
                                                    <img
                                                        src={review.ReviewImage[0]}
                                                        alt="review-1"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                    />
                                                </Box>
                                            )}
                                            {review.ReviewImage.length === 2 && (
                                                <Grid container spacing={1}>
                                                    {review.ReviewImage.map((img, i) => (
                                                        <Grid item xs={6} key={i}>
                                                            <Box sx={{ height: '180px' }}>
                                                                <img
                                                                    src={img}
                                                                    alt={`review-2-${i}`}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            )}
                                            {review.ReviewImage.length === 3 && (
                                                <Box>
                                                    <Box sx={{ width: '100%', height: '200px', mb: 1 }}>
                                                        <img
                                                            src={review.ReviewImage[0]}
                                                            alt="review-3-0"
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                        />
                                                    </Box>
                                                    <Grid container spacing={1}>
                                                        {[1, 2].map((i) => (
                                                            <Grid item xs={6} key={i}>
                                                                <Box sx={{ height: '120px' }}>
                                                                    <img
                                                                        src={review.ReviewImage[i]}
                                                                        alt={`review-3-${i}`}
                                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Box>
                                            )}
                                            {review.ReviewImage.length >= 4 && (
                                                <Grid container spacing={1}>
                                                    {review.ReviewImage.slice(0, 4).map((img, i) => (
                                                        <Grid item xs={6} key={i}>
                                                            <Box sx={{ height: '130px' }}>
                                                                <img
                                                                    src={img}
                                                                    alt={`review-4-${i}`}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            )}
                                        </Box>
                                    )}

                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <Box
                                            sx={{
                                                width: '50px',
                                                height: '50px',
                                                mr: 1,
                                                borderRadius: '50px',
                                                backgroundColor: theme.palette.primary.gold,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#fff',
                                                fontWeight: 600,
                                                fontSize: '20px',
                                                textTransform: 'uppercase',
                                            }}
                                        >
                                            {review.name?.charAt(0)}
                                        </Box>

                                        <Box>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    color: '#fff',
                                                    fontSize: '16px',
                                                    fontFamily: theme.palette.typography.fontFamily1,
                                                }}
                                            >
                                                {review.name}
                                            </Typography>
                                            <Box sx={{ color: '#FFD700' }}>
                                                {[...Array(parseInt(review?.ReviewStart))].map((_, i) => (
                                                    <StarIcon key={i} />
                                                ))}
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#fff',
                                            fontSize: '16px',
                                            fontFamily: theme.palette.typography.fontFamily1,
                                            lineHeight: '1.6',
                                        }}
                                    >
                                        {review?.Description}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))
                    )}
                </Box>
            </Container>
        </Box>
    );
};

const SampleNextArrow = (props) => {
    const theme = useTheme();
    const { onClick } = props;

    return (
        <Button sx={{
            display: { xl: 'block', xs: 'none' }, color: theme.palette.primary.gold, position: 'absolute', top: '42%', zIndex: '1111',
            '&:hover': { backgroundColor: 'transparent' }, right: '-5%', border: '1px solid #fff', borderRadius: '50%'
        }} onClick={onClick}>
            <img src='/images/Banner/next.svg' alt="Next" />
        </Button>
    );
};

const SamplePrevArrow = (props) => {
    const theme = useTheme();
    const { onClick } = props;

    return (
        <Button sx={{
            color: theme.palette.primary.gold, position: 'absolute', top: '42%', left: '-5%', zIndex: '1111',
            '&:hover': { backgroundColor: 'transparent' }, border: '1px solid #fff', borderRadius: '50%', display: { xl: 'block', xs: 'none' },
        }} onClick={onClick}>
            <img src='/images/Banner/back.svg' alt="Previous" />
        </Button>
    );
};

const ReviewCard = ({ review }) => {
    const theme = useTheme();

    return (
        <Grid
            item
            xs={12}
            lg={3}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Box
                sx={{
                    padding: { sm: '38px 20px', xs: '18px 20px' },
                    backgroundColor: '#23201e',
                    mx: { xxl: 2, xs: 1 },
                    borderRadius: '8px',
                    width: '100%',
                }}
            >
                {/* Review Images */}
                {review.ReviewImage && Array.isArray(review.ReviewImage) && review.ReviewImage.length > 0 && (
                    <Box sx={{ mb: 2 }}>
                        {review.ReviewImage.length === 1 && (
                            <Box sx={{ width: '100%', height: '250px' }}>
                                <img
                                    src={review.ReviewImage[0]}
                                    alt="review-1"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                />
                            </Box>
                        )}
                        {review.ReviewImage.length === 2 && (
                            <Grid container spacing={1}>
                                {review.ReviewImage.map((img, i) => (
                                    <Grid item xs={6} key={i}>
                                        <Box sx={{ height: '180px' }}>
                                            <img
                                                src={img}
                                                alt={`review-2-${i}`}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                        {review.ReviewImage.length === 3 && (
                            <Box>
                                <Box sx={{ width: '100%', height: '200px', mb: 1 }}>
                                    <img
                                        src={review.ReviewImage[0]}
                                        alt="review-3-0"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                    />
                                </Box>
                                <Grid container spacing={1}>
                                    {[1, 2].map((i) => (
                                        <Grid item xs={6} key={i}>
                                            <Box sx={{ height: '120px' }}>
                                                <img
                                                    src={review.ReviewImage[i]}
                                                    alt={`review-3-${i}`}
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                />
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        )}
                        {review.ReviewImage.length >= 4 && (
                            <Grid container spacing={1}>
                                {review.ReviewImage.slice(0, 4).map((img, i) => (
                                    <Grid item xs={6} key={i}>
                                        <Box sx={{ height: '130px' }}>
                                            <img
                                                src={img}
                                                alt={`review-4-${i}`}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Box>
                )}

                {/* Reviewer Name + Star */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box
                        sx={{
                            width: '50px',
                            height: '50px',
                            mr: 1,
                            borderRadius: '50px',
                            backgroundColor: theme.palette.primary.gold,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontWeight: 600,
                            fontSize: '20px',
                            textTransform: 'uppercase',
                        }}
                    >
                        {review.name?.charAt(0)}
                    </Box>

                    <Box>
                        <Typography
                            variant="h6"
                            sx={{
                                color: '#fff',
                                fontSize: '16px',
                                fontFamily: theme.palette.typography.fontFamily1,
                            }}
                        >
                            {review.name}
                        </Typography>
                        <Box sx={{ color: '#FFD700' }}>
                            {[...Array(parseInt(review?.ReviewStart || 0))].map((_, i) => (
                                <StarIcon key={i} />
                            ))}
                        </Box>
                    </Box>
                </Box>

                {/* Review Description */}
                <Typography
                    variant="body2"
                    sx={{
                        color: '#fff',
                        fontSize: '16px',
                        fontFamily: theme.palette.typography.fontFamily1,
                        lineHeight: '1.6',
                    }}
                >
                    {review?.Description}
                </Typography>
            </Box>
        </Grid>
    );
};

export default Review;


